import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BsToggleOn } from "react-icons/bs";
import "react-toggle/style.css" ;

import { toggleDarkMode } from "../../state/action";

export const DarkModeToggle = () => {
  const { isDarkMode } = useSelector(({ common }) => common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [isDarkMode]);

  return (
    <BsToggleOn onClick={() => dispatch(toggleDarkMode(!isDarkMode))} />
  );
};